import React, { useState } from 'react';
import logo from './logo.svg';
import './App.css';
import { AuthProvider } from './hooks/useAuth';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NotificationServiceProvider } from './components/notification';
import Router from './routes';
import { ThemeProvider } from '@mui/material';
import { darkTheme, lightTheme } from './theme';

const queryClient = new QueryClient();

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  return (
    <AuthProvider>
    <QueryClientProvider client={queryClient}>
      <NotificationServiceProvider>
        <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
          <Router />
        </ThemeProvider>
      </NotificationServiceProvider>
    </QueryClientProvider>
    </AuthProvider>
  );
}

export default App;
